import React from 'react';
const MatomoContext = React.createContext({});
export default MatomoContext;
//# sourceMappingURL=MatomoContext.js.map